/** windsurf generated code start */
import { cachedAPIWrapper } from "../../apiCaching/apiWrapper";
import { isTestEnvironment } from "../../apiCaching/POST-Requests/helperModules/helperFunctions";
import { apiConfig } from "../../config/apiConfig";

/**
 * Prefetches webpack chunks by fetching the chunking manifest and sending to service worker
 * @returns {Promise<void>}
 */
export async function backgroundFetchChunks(): Promise<void> {
    const url = `${apiConfig.CHUNKING_MANIFEST}?v=${Date.now()}`;
    
    try {
        const response = await cachedAPIWrapper(url, 0, false);
        
        if(isTestEnvironment()){
            console.log("[Chunk] manifest response", response);
        }
        
        const chunklist: string[] = [];
        const chunkObjs = response.chunks;
        
        for(const chunk of chunkObjs){
            if(chunk.files[0]?.includes("o2/opus2") && chunk.publicUrls[0]?.includes("o2/opus2")){
                chunklist.push(chunk.publicUrls[0]);
            }
        }
        if(isTestEnvironment()){
            console.log("[Chunk] chunklist", chunklist);
        }
        
        // Send chunks to service worker for prefetching and IndexedDB storage
        if(chunklist.length > 0) {
            sendChunksToServiceWorker(chunklist);
        }
    } catch(error) {
        console.warn("[Chunk] unable to fetch the chunking manifest", error);
    }
}

/**
 * Sends chunk URLs to service worker for prefetching and IndexedDB storage
 * @param {string[]} urls - Array of chunk URLs to prefetch
 * @returns {void}
 */
function sendChunksToServiceWorker(urls: string[]): void {
    if (!navigator?.serviceWorker?.controller) {
        console.warn('[Chunk] Service worker not available, falling back to direct fetch');
        return;
    }
    
    const origin = globalThis.location.origin;
    
    // Ensure all URLs have the origin
    const urlsWithOrigin = urls.map(url => {
        if (url.startsWith(origin) || url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }
        return `${origin}${url}`;
    });
    
    // Remove duplicates
    const uniqueUrls = Array.from(new Set(urlsWithOrigin));
    
    if(isTestEnvironment()){
        console.log('[Chunk] Sending prefetch request to service worker:', uniqueUrls);
    }
    
    // Send message to service worker to prefetch chunks
    navigator.serviceWorker.controller.postMessage({
        type: 'PREFETCH_CHUNKS',
        urls: uniqueUrls,
        origin: origin
    });
}


